import "../node_modules/react-grid-layout/css/styles.css";
import "../node_modules/react-resizable/css/styles.css";
import "./App.css";

import { useEffect } from "react";
import { useSelector } from "react-redux";
import { AppRoutes } from "./config/routeConfig";

function App() {
  const appTheme = useSelector(state => state.application.theme);

  useEffect(() => {
    const normalizedTheme = (appTheme || "light").toLowerCase();
    // TODO: Change to normalizedTheme when we have a light theme
    document.body.className = `theme-dark`;
    document.body.setAttribute("data-theme", "dark");
    // TODO: Change to themeName when we have a light theme
  }, [appTheme]);

  return (
    <div className="App" data-theme={appTheme}>
      <AppRoutes />
    </div>
  );
}

export default App;
